import { render, staticRenderFns } from "./ModifyAdditionalPackageModal.vue?vue&type=template&id=6f0f411a&scoped=true&"
import script from "./ModifyAdditionalPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyAdditionalPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f411a",
  null
  
)

export default component.exports